<div class="mb-16 flex flex-col">
  <div class="mx-auto mb-6 mt-10 flex w-[80%] flex-col gap-4">
    <h1 class="text-3xl">Facturas no procesables para gastos</h1>

    <!-- SELECTOR DE COLUMNAS-->
    <div class="relative flex gap-4">
      <button
        (click)="toogleColumnDropdown()"
        class="btn flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
      >
        {{ isColumnDropdownOpen ? 'Ocultar menú de columnas' : 'Mostrar menú de columnas' }}
      </button>
      <div *ngIf="isColumnDropdownOpen" class="dropdown-menu">
        <div
          *ngFor="let option of columnOptions"
          (click)="toggleColumnaSeleccionada(option)"
          [class.selected]="option.selected"
        >
          {{ option.headerName }}
        </div>
      </div>
      <app-copy-to-excel-button [gridApi]="gridApi" />
    </div>
  </div>

  <!-- TABLA DE FACTURAS -->
  <ag-grid-angular
    style="height: 69vh"
    class="ag-theme-quartz mx-auto"
    [gridOptions]="gridOptions"
    [rowData]="facturas"
    [columnDefs]="columnDefs"
  />
</div>
